import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-found",
  "use": "icon-found-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-found\"><path d=\"M915.446 932.021c-2.089 0-4.303-0.316-6.572-0.927l-264.618-104.107-262.942 106.888-265.7-104.978c-13.966-3.87-25.402-18.985-25.402-33.482l0-685.068c0-12.172 8.012-20.277 18.831-20.222 2.089 0 4.303 0.254 6.572 0.927l265.391 104.31 263.308-104.36 264.563 109.825c13.966 3.92 25.402 19.034 25.402 33.532l0 677.439c0 12.172-8.012 20.222-18.831 20.222zM353.983 239.014l-211.013-78.061 0 620.743 211.013 86.067 0-628.749zM406.736 868.184l211.019-83.526 0-628.533-211.019 82.791 0 629.269zM881.518 248.028l-211.013-91.112 0 627.142 211.013 79.557 0-615.588z\" p-id=\"1255\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/found.svg
// module id = RlNO
// module chunks = 2